import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { SET_SEARCH } from "redux/search";
import routes from "routes";
import { entityType } from "utils/commons";
import trackEvent from "utils/trackEvent";

// Maps a chat document type to the matching SERP tab. SERP's own redux
// search state (redux/search.js) only supports a free-text query per tab,
// not "these exact document codes" - so, like the traditional SearchBar,
// this re-runs the user's original question as a SERP text search on the
// tab that matches the answer's dominant document type, rather than trying
// to introduce a new codes-based search mode into SERP.
const TAB_BY_ENTITY_TYPE = {
  [entityType.QUALIFICATION]: "quals",
  [entityType.OFFERING_TOPIC]: "offerings",
  [entityType.BUSINESS_CHALLENGE]: "businessChallenges",
};

const dominantTab = documents => {
  const counts = {};
  documents.forEach(d => {
    const tab = TAB_BY_ENTITY_TYPE[d.type];
    if (tab) counts[tab] = (counts[tab] || 0) + 1;
  });
  const [best] = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  return best ? best[0] : "offerings";
};

// Shown when the answer is a "bullet list of N" (is_tile_list), letting the
// user jump to the existing SERP tile view instead of reading it as chat
// text - low priority per the plan, built last.
const TileViewButton = ({ message, searchSerp, setSearch }) => {
  const history = useHistory();
  if (!message.isTileList) return null;

  const handleClick = () => {
    const tab = dominantTab(message.documents || []);
    const q = message.question || "";
    trackEvent("CHAT_TILE_VIEW", { tab, q });
    setSearch({
      ...(searchSerp || {}),
      selectedTab: tab,
      [tab]: { ...(searchSerp?.[tab] || {}), q },
    });
    history.push(`${routes.SERP}?q=${encodeURIComponent(q)}`);
  };

  return (
    <button
      type="button"
      className="chat-result-action-btn"
      title="Transfer to traditional search"
      aria-label="Transfer to traditional search"
      onClick={handleClick}>
      Transfer to traditional search
    </button>
  );
};

export default connect(
  ({ search: { serp } }) => ({ searchSerp: serp }),
  dispatch => ({
    setSearch: payload => dispatch(SET_SEARCH({ serp: payload })),
  })
)(TileViewButton);
